var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#2F4DC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9457 9.12193L11.5923 17.1836L9.37568 14.8153C8.96734 14.4303 8.32568 14.4069 7.85901 14.7336C7.40401 15.0719 7.27568 15.6669 7.55568 16.1453L10.1807 20.4153C10.4373 20.8119 10.8807 21.0569 11.3823 21.0569C11.8607 21.0569 12.3157 20.8119 12.5723 20.4153C12.9923 19.8669 21.0073 10.3119 21.0073 10.3119C22.0573 9.2386 20.7857 8.2936 19.9457 9.11027V9.12193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b8944d2f83e5dbea86d042850e901dbc.svg";
export { ForwardRef as ReactComponent };